import authRules from '../authRules.js';

const viewActivityType = (user) => {
  const { updateActivityCodeInApprovals } = user.securityLevels;
  if (updateActivityCodeInApprovals >= authRules.viewActivityType.updateActivityCodeInApprovals) {
      return true;
  } else {
      return false;
    }
  }


export default viewActivityType;